module.exports = __webpack_public_path__ + "static/scale-model-of-tulsa-zoo-in-tulsa-oklahoma-d938043d0e52916671fccd46bb1ba298.png";